import {get, post} from "../base.js" 

// 获取照片列表
function getImageList(payload) {
  return get("/livestream/album/index", payload)
}

// 获取水印信息
function getWaterMark(payload) {
  return get("/livestream/album/watermark", payload)
}

// 获取热门照片
function getHotPhoto(payload) {
  return get("/livestream/photo/hot-list", payload)
}
// 获取照片点赞人数
function getLikeNum(payload) {
  return get("/livestream/photo/like-num", payload)
}
// 照片点赞与取消, 
function photoLike(payload) {
  return post("/livestream/photo/like", payload)
}

// 照片直播数据统计, 
function calcPvData(payload) {
  return get("/livestream/track/lp-stat", payload)
}

// 水印区间获取, 
function getWatermarkArea(payload) {
  return get("/livestream/album/timeline-part", payload)
}

// 水印区间照片获取, 
function getAreaImage(payload) {
  return get("/livestream/album/timeline-picture", payload)
}

// 获取照片信息
function getImgInfo(url, payload) {
  return get(url, payload)
}

export default {
  getImageList,
  getWaterMark,
  getHotPhoto,
  getLikeNum,
  photoLike,
  calcPvData,

  getWatermarkArea,
  getAreaImage,
  getImgInfo
}


// WEBPACK FOOTER //
// ./src/api/image/image.js